import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const detailsContainerStyle = css`
  border-left: 1px solid ${theme.colors.neutral20};
  flex: 1;
  position: relative;
`;
